import * as React from 'react';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UILink from 'UIComponents/link/UILink';
import FlowNameLabel from 'flow-doctor-lib/components/common/FlowNameLabel';
import ObjectNameLabel from 'flow-doctor-lib/components/common/ObjectNameLabel';
import { getIsInternal } from 'flow-doctor-lib/constants/Env';
import { getCanvasUrl } from 'flow-doctor-lib/utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
const ActionExecutionEnrollmentAnalysisDetails = ({
  selectedEnrollment
}) => {
  const enrollingFlowId = selectedEnrollment.contextMap.SOURCE_FLOW_ID;
  return /*#__PURE__*/_jsx("p", {
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: enrollingFlowId ? 'flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.enrollTypeDetail.ACTION_EXECUTION_ENROLL.withFlow_jsx' : 'flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.enrollTypeDetail.ACTION_EXECUTION_ENROLL.withoutFlow_jsx',
      elements: {
        ViewLink: UILink,
        ObjectNameLabel,
        FlowNameLabel,
        b: 'b'
      },
      options: {
        objectNameLabel: {
          portalId: selectedEnrollment.portalId,
          objectTypeId: selectedEnrollment.objectTypeId,
          objectId: selectedEnrollment.objectId,
          showId: getIsInternal()
        },
        flowNameLabel: {
          portalId: selectedEnrollment.portalId,
          flowId: enrollingFlowId
        },
        viewLink: {
          external: true,
          href: enrollingFlowId ? getCanvasUrl({
            portalId: selectedEnrollment.portalId,
            flowId: enrollingFlowId
          }) : undefined
        }
      }
    })
  });
};
export default ActionExecutionEnrollmentAnalysisDetails;